import { useIntl } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { DropdownContent } from '@/patterns/global-nav/src/dropdown-content';

import { useJiraTemplateCategories } from './client/use-template-categories';

export const TemplateCategoriesDropdown = () => {
	const intl = useIntl();
	const { data } = useJiraTemplateCategories();
	const getLocalizedHref = useLocalizedHref;

	const allTemplateLink = {
		text: intl.formatMessage({
			id: 'ira.TemplateCategoriesDropdown.allTemplates',
			defaultMessage: 'All templates',
		}),
		href: useLocalizedHref('/software/jira/templates'),
	};

	const templateLinks = data.map((category) => ({
		text: category.categoryNameExternal,
		href: getLocalizedHref(`/software/jira/templates/${category.urlSlug}`),
	}));

	const jsmTemplatesLink = {
		text: intl.formatMessage({
			id: 'Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates',
			defaultMessage: 'Jira Service Management templates',
		}),
		href: useLocalizedHref('/software/jira/templates/service-management'),
		anchorProps: {
			target: '_blank',
		},
	};

	return (
		<DropdownContent
			orientation="column"
			contentSections={[
				{
					links: [allTemplateLink, ...templateLinks],
				},
				{
					links: [jsmTemplatesLink],
				},
			]}
		/>
	);
};
